import { useMutation } from '@vue/apollo-composable';
import { computed, type Ref, ref, watch } from 'vue';
import { CREATE_GIFTY_APP } from './graphql';

export const useApiKey = (enabled: Ref<boolean>) => {
  const apiToken = ref('');
  const created = ref(false);
  const changingKey = ref(false);
  const saveFailed = ref(false);

  const connected = computed(() => enabled.value || created.value);
  const keyLocked = computed(() => connected.value && !changingKey.value);

  watch(apiToken, () => {
    saveFailed.value = false;
  });

  const { mutate: createApp, loading: savingKey } =
    useMutation(CREATE_GIFTY_APP);

  const saveKey = (): Promise<boolean> =>
    createApp({
      input: {
        apiToken: apiToken.value,
      },
    })
      .then((response) => {
        if (response?.data?.createGiftyApp?.errors?.length) {
          saveFailed.value = true;
          return false;
        }

        created.value = true;
        changingKey.value = false;
        return true;
      })
      .catch(() => {
        saveFailed.value = true;
        return false;
      });

  const changeKey = () => {
    apiToken.value = '';
    changingKey.value = true;
  };

  const keepKey = () => {
    apiToken.value = '';
    changingKey.value = false;
  };

  return {
    apiToken,
    changingKey,
    connected,
    keyLocked,
    saveFailed,
    savingKey,
    saveKey,
    changeKey,
    keepKey,
  };
};
